<template>
  <v-card class="create-rbu">
    <v-card-title>Import SoR and RBU Formula</v-card-title>
    <v-card-text style="display: flex; flex-direction: column"
      ><span>Please make sure you pick the correct SoR and RBU</span>
      <span>(The Config will also be overwritten by the import RBU)</span>
    </v-card-text>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-select
          outlined
          clearable
          :label="$t('rbu.imported_sor')"
          :items="sorOptions"
          v-model="result.sor_id"
          :rules="requiredRules"
        ></v-select>
        <v-select
          outlined
          clearable
          :label="'Import RBU (Optional)'"
          :items="rbuOptions"
          v-model="result.rbu_id"
        ></v-select>
        <span v-if="result.rbu_id" style="color: red"
          >After copying from RBU, Please manually modify the base start and end
          in the configurations.</span
        >
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import { SOR_TYPE } from "@/constants";

export default {
  name: "RbuImportSorAndRbuDialog",
  props: {
    editionId: String,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const sors = ref([]);
    const rbus = ref([]);

    const getSors = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/sor/",
        params: {
          page_size: -1,
          filters: {
            type: [SOR_TYPE.SOR, SOR_TYPE.CORRIGENDUM],
            action_input_finalised_at: true,
          },
        },
      });

      if (response.body.success) {
        sors.value = response.body.sors;
      }
    };

    const getRbu = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/edition/",
        params: {
          page_size: -1,
          filters: {},
        },
      });

      if (response.body.success) {
        rbus.value = response.body.editions;
      }
    };

    const sorOptions = computed(() => {
      return sors.value.map((s) => {
        const type =
          s.type === SOR_TYPE.CORRIGENDUM
            ? "Corrigendum"
            : s.type === SOR_TYPE.SOR
            ? "SoR"
            : s.type;
        return { text: `[${type}] ${s.name}`, value: s.id };
      });
    });

    const rbuOptions = computed(() => {
      return rbus.value
        .filter((s) => {
          return s.id != props.editionId;
        })
        .sort((a, b) => a.edition.localeCompare(b.edition))
        .map((s) => {
          return { text: `[${s.edition}] ${s.name}`, value: s.id };
        });
    });

    const result = ref({
      edition_id: props.editionId,
      sor_id: null,
      rbu_id: null,
    });

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/edition/import_sor/",
        params: {
          ...result.value,
        },
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    onMounted(() => {
      getSors();
      getRbu();
    });

    return {
      requiredRules,
      sorOptions,
      rbuOptions,
      result,
      save,
    };
  },
};
</script>
